import { useParams, Link } from 'react-router-dom'
import HeroCTA from '../components/HeroCTA'
import { getProjectById } from '../data/projects'
import './ProjectDetailsPage.css'

function ProjectDetailsPage() {
  const { id } = useParams<{ id: string }>()
  const project = id ? getProjectById(parseInt(id, 10)) : undefined

  if (!project) {
    return (
      <div className="project-details-page">
        <div className="container">
          <div className="project-not-found">
            <h1>Project Not Found</h1>
            <p>The project you're looking for doesn't exist or may have been removed.</p>
            <Link to="/projects" className="back-link">
              ← Back to Completed Projects
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="project-details-page">
      <section className="project-details-hero">
        <div className="container">
          <Link to="/projects" className="back-link">
            ← Back to Completed Projects
          </Link>
          <div className="project-details-header">
            <span className="project-meta">
              {project.category} • {project.year}
            </span>
            <h1>{project.title}</h1>
          </div>
        </div>
      </section>

      <section className="project-details-content">
        <div className="container">
          <div className="project-description">
            <h2>Project Overview</h2>
            <p>{project.detailedDescription}</p>
          </div>

          {(project.beforeImage || project.afterImage) && (
            <div className="before-after-section">
              <h2>Before &amp; After</h2>
              <div className="before-after-grid">
                {project.beforeImage && (
                  <div className="before-after-card">
                    <img
                      src={project.beforeImage}
                      alt={`${project.title} - Before installation`}
                      className="before-after-image"
                      loading="lazy"
                    />
                    <span className="before-after-label">Before</span>
                  </div>
                )}
                {project.afterImage && (
                  <div className="before-after-card">
                    <img
                      src={project.afterImage}
                      alt={`${project.title} - After installation`}
                      className="before-after-image"
                      loading="lazy"
                    />
                    <span className="before-after-label">After</span>
                  </div>
                )}
                {project.additionalImages?.map((src, i) => (
                  <div key={src} className="before-after-card">
                    <img
                      src={src}
                      alt={`${project.title} - After installation ${i + 2}`}
                      className="before-after-image"
                      loading="lazy"
                    />
                    <span className="before-after-label">After</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      <section className="project-details-cta">
        <div className="container">
          <div className="project-details-cta-content">
            <h2>Ready to Start Your Project?</h2>
            <p>
              Let us help you create exactly the lab you need. Our team brings extensive parts
              knowledge and service expertise to every project.
            </p>
            <HeroCTA />
          </div>
        </div>
      </section>
    </div>
  )
}

export default ProjectDetailsPage
